import { render, staticRenderFns } from "./auth-login.vue?vue&type=template&id=be4d0d68&scoped=true&"
import script from "./auth-login.vue?vue&type=script&lang=js&"
export * from "./auth-login.vue?vue&type=script&lang=js&"
import style0 from "./auth-login.vue?vue&type=style&index=0&id=be4d0d68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4d0d68",
  null
  
)

export default component.exports